/**
 * Constantes de labels para la aplicación
 * Centraliza todos los textos mostrados en la UI
 */

// Labels del HeaderInfo
export const HEADER_LABELS = {
  TITLE: 'Informe Siniestral',
  SUBTITLE:
    'Seleccioná el periodo de hasta 12 meses para generar el Informe. Podés elegir cómo visualizar los datos y descargarlo completo.',
}

// Labels del DateRangeSelector
export const DATE_RANGE_LABELS = {
  FROM: 'Desde',
  TO: 'Hasta',
  GENERATE_REPORT: 'Generar Informe',
  GENERATING: 'Generando...',
}

// Labels de InformeTabs
export const TABS_LABELS = {
  CHARTS: 'Gráficos',
  TABLE: 'Tabla',
  CHARTS_VIEW: 'Vista de Gráficos - Datos:',
  TABLE_VIEW: 'Vista de Tabla - Datos:',
}

// Labels de EmptyMessage
export const EMPTY_MESSAGE_LABELS = {
  TITLE: 'No se registran siniestros para el período seleccionado',
  DESCRIPTION: 'Podés descargar el Informe sin siniestros.',
}

// Labels del Menu/Navbar
export const MENU_LABELS = {
  HOME: 'Inicio',
  LOGO_ALT: 'logo-provincia-art',
}

// Labels del Footer
export const FOOTER_LABELS = {
  GROUP_LOGO_ALT: 'logo-grupo-provincia',
  ART_LOGO_ALT: 'logo-provincia-art',
}

// Labels de NotFound
export const NOT_FOUND_LABELS = {
  ERROR_CODE: '404',
  TITLE: 'Somethings missing.',
  DESCRIPTION: 'Sorry, we cant find that page. Youll find lots to explore on the home page.',
  BACK_BUTTON: 'Back to Homepage',
}

// Labels de ErrorFallback (Sentry ErrorBoundary)
export const ERROR_FALLBACK_LABELS = {
  TITLE: 'Ocurrió un error inesperado',
  DESCRIPTION: 'El equipo fue notificado automáticamente. Por favor, intentá recargar la página.',
  RETRY: 'Reintentar',
}

export const AUTH_LABELS = {
  LOADING: 'Cargando...',
  INVALID_LINK_MESSAGE: 'El enlace que usaste es inválido o ya no está disponible.',
  DEFAULT_AUTH_ERROR: 'No se pudo autenticar la sesión.',
  ACCESS_RESTRICTED_TITLE: 'Acceso restringido',
  ACCESS_RESTRICTED_MESSAGE: 'Se requiere un enlace de acceso válido para visualizar esta página.',
  ACCESS_RESTRICTED_HELP: 'Si llegaste aquí desde un enlace, por favor verificá que sea correcto.',
}

export const TABLAS_LABELS = {
  TOP_DENUNCIANTES: 'Total histórico de personas trabajadoras con más denuncias',
  TOP_JUDICIALES: 'Total histórico de personas trabajadoras con más juicios',
  TOP_SINIESTROS: 'Evolución mensual de siniestros',
  TOP_ASEGURADORAS: 'Top Aseguradoras',
  NO_JUICIOS_MESSAGE: 'No se registran juicios asociados a siniestros',
  TOP_RANKING_SINIESTROS: 'Top 5 de denuncias',
  NO_DATA_PERIOD: 'para el período seleccionado',
}

export const TIPOS_DENUNCIAS = [
  { tipoId: 1, tipoDescripcion: 'Lugar de trabajo' },
  { tipoId: 2, tipoDescripcion: 'In itínere' },
  { tipoId: 3, tipoDescripcion: 'Enfermedad profesional' },
]

export const INDICADORES_LABELS = {
  TITLE: 'Indicadores',
}

export const TIPOS_INDICADORES = [
  { tipoId: 1, tipoDescripcion: 'Denuncias' },
  { tipoId: 2, tipoDescripcion: 'Estado de los siniestros' },
  { tipoId: 3, tipoDescripcion: 'Indicadores frecuenciales' },
]

export const INDICADORES_INFO = {
  totalDenuncias: 'Cantidad de siniestros denunciados durante el periodo seleccionado (incluye siniestros rechazados).',
  autodenuncias:
    'Cantidad de siniestros denunciados directamente por persona trabajadora durante el periodo seleccionado.',
  rechazos: 'Cantidad de siniestros rechazados durante el periodo seleccionado.',
  altas: 'Cantidad de siniestros que fueron cerrados (con alta médica) durante el periodo seleccionado.',
  recaidas: 'Cantidad de siniestros reingresados durante el periodo seleccionado.',
  diasBajaPromedio:
    'Promedio de los días de baja de todos los siniestros cerrados (con alta médica) durante el periodo seleccionado.',
  frecuenciaSiniestral:
    'Se calcula la relación de los siniestros aceptados sobre el promedio de personas trabajadoras (cápitas) de los últimos 12 meses.',
  frecuenciaJudicial:
    'Cantidad de juicios ingresados sobre la cantidad de siniestros originales denunciados. Es un dato anualizado: se consideran los últimos 12 meses de juicios y siniestros medidos desde el último período seleccionado.',
  frecuenciaSiniestralCiiu:
    'Cantidad de siniestros originales aceptados sobre el promedio de cápitas. Es un dato anualizado: se consideran los últimos 12 meses de siniestros y cápitas del mismo CIIU al que corresponde la empresa analizada, medidos desde el último período seleccionado.',
}

export const ALERT_MESSAGES = {
  errorMsj: 'Hubo un error al generar el informe.\nIntentá nuevamente más tarde.',
  successMsj: 'Informe generado exitosamente',
}
